module.exports = new __parcel__URL__("atom-heart-mother.7e2bf9fe.jpg").toString();